import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CdkTrapFocus } from '@angular/cdk/a11y';

@Component({
  selector: 'lib-mobile-overlay',
  templateUrl: './mobile-overlay.component.html',
  styleUrls: ['./mobile-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CdkTrapFocus],
})
export class MobileOverlayComponent {
  hideFooter = input(false);
}
